<!-- Tile that has the same dimensions as PreviewImage. It will occupy a slot in a closet section and have an optional call to action button -->
<template>
  <div
    class="tile-cta d-flex flex-column row-gap-xs justify-content-center align-items-center text-center">
    <slot name="icon"/>
    <b
      v-if="title"
      class="title">
      {{ title }}
    </b>
    <p
      v-if="description"
      class="description small-text">
      {{ description }}
    </p>
    <slot name="button"/>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: false,
    default: ''
  },
  description: {
    type: String,
    required: false,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
@import '../../../shared/components/ADORN/PreviewImage.scss';

.tile-cta {
  border-radius: 2px;
  border: 3px solid $orchid;
  background: $origami;
  padding: 0 12px;
  aspect-ratio: #{$image-aspect-ratio};
}

</style>
